import styled from 'styled-components';

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: ${props =>
    props.accentColor || props.theme.colors.porterPrimary};
`;

export const CheckboxLabelWrapper = styled.label`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: 1.2;
  color: ${props => props.theme.colors.highBlack};
  cursor: pointer;
  font-weight: 400;
  margin: 0;
  box-sizing: border-box;

  a {
    ::before {
      content: ' ';
    }

    :hover {
      text-decoration: none;
      color: ${props => props.linkColor || props.theme.colors.porterPrimary};
    }
  }
`;
